<template>
    <div class="answer">
        <div class="title">提交成功</div>
    </div>
</template>
<script>

export default {

    dicts: ["difficulty", "question_type"],
    data() {
        return {

        };
    },
    created() {

    },
    mounted() {

    },
    methods: {}
};
</script>
<style scoped lang="scss">
.answer {
    width: 1000px;
    height: 100%;
    // background: #f2f2f2;
    margin: 0 auto;

}

.title {
    text-align: center;
    margin-top: 250px;
}
</style>